import AwesomeSlider from 'react-awesome-slider';
import withAutoplay from 'react-awesome-slider/dist/autoplay';
import 'react-awesome-slider/dist/styles.css';
import styled from 'styled-components';

const AutoSlider = withAutoplay(AwesomeSlider);

export const StyledAutoSlider = styled(AutoSlider)`
  .awssld__timer {
    background-color: transparent;
  }
  nav.awssld__bullets {
    bottom: 10px;
    z-index: 10;
    button {
      background-color: rgba(239, 239, 239, 0.6);
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);
      height: 10px;
      width: 10px;
    }
    button.awssld__bullets--active {
      background-color: white;
      transform: unset;
    }
  }
  .awssld__next,
  .awssld__prev {
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
  }
  &:hover {
    .awssld__next,
    .awssld__prev {
      opacity: 1;
    }
  }
`;
